var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCushmanAndWakefield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 37,
    viewBox: "0 0 173 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139_29890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8961 0.5V36.5H36.5415V8.50327L25.8961 0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6642 3.68365V36.5H23.8415V2.04767L21.6642 3.68365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4322 36.5H19.6095V5.23132L17.4322 6.8673V36.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2003 36.5H15.3733V8.41077L13.2003 10.051V36.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5962 16.6369V36.5H49.2374V24.6402L38.5962 16.6369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96405 19.7785V36.5H11.1413V18.1425L8.96405 19.7785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.73206 36.5H6.90934V21.3262L4.73206 22.9622V36.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.500122 36.5H2.6774V24.5098L0.500122 26.1458V36.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7304 20.5439C73.53 20.5439 71.5684 18.765 71.5684 15.2743V8.49487H74.1896V15.2028C74.1896 17.1332 75.1619 18.1341 76.76 18.1341C78.3581 18.1341 79.3305 17.1668 79.3305 15.2869V8.49487H81.9517V15.186C81.9517 18.7776 79.9266 20.5397 76.722 20.5397L76.7304 20.5439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8532 20.5271C88.048 20.5271 86.2258 19.9005 84.7969 18.6304L86.3485 16.7841C87.4223 17.6631 88.5469 18.2224 89.9082 18.2224C90.982 18.2224 91.6289 17.7977 91.6289 17.1038V17.0701C91.6289 16.4098 91.2188 16.0692 89.2275 15.5603C86.8262 14.9505 85.2746 14.2397 85.2746 11.8846V11.851C85.2746 9.69768 87.0122 8.27618 89.4474 8.27618C91.185 8.27618 92.6647 8.81871 93.8738 9.786L92.5125 11.75C91.4556 11.0224 90.4198 10.5809 89.4136 10.5809C88.4074 10.5809 87.8789 11.0393 87.8789 11.6154V11.6491C87.8789 12.4271 88.3904 12.7299 90.4493 13.2556C92.8676 13.8823 94.2289 14.7444 94.2289 16.8136V16.8472C94.2289 19.2024 92.4237 20.5229 89.8532 20.5229V20.5271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.242 20.3547V15.5939H100.406V20.3547H97.7844V8.49487H100.406V13.1883H105.242V8.49487H107.863V20.3547H105.242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.741 20.3547L145.127 12.936V20.3547H142.539V8.49487H144.958L150.542 16.0397V8.49487H153.13V20.3547H150.741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4502 36.5L95.7552 31.4533L94.3769 32.8748V36.5H91.7557V24.6402H94.3769V29.8257L99.2135 24.6402H102.38L97.5266 29.6701L102.6 36.4958H99.4502V36.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.547 36.5V24.6402H114.459V26.9617H108.151V29.3673H113.693V31.6888H108.151V34.1785H114.543V36.5H105.547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.892 36.5V24.6402H133.513V36.5H130.892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.381 36.4832V24.6234H146.294V26.9448H139.986V29.3505H145.528V31.672H139.986V34.1617H146.378V36.4832H137.381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.297 36.5V24.6402H152.918V34.128H158.862V36.5H150.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.663 36.5H162.012V24.6402H166.663C170.408 24.6402 173 27.1972 173 30.5365V30.5701C173 33.9094 170.413 36.5 166.663 36.5ZM170.256 30.5701C170.256 28.4673 168.81 26.9953 166.663 26.9953H164.638V34.1449H166.663C168.81 34.1449 170.256 32.7066 170.256 30.6038V30.5701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7809 18.1383C61.5993 18.1762 60.1408 16.5065 60.107 14.4752V14.4416C60.0689 12.4103 61.5063 10.7238 63.616 10.686C64.804 10.665 65.8482 11.1822 66.5458 11.9981L68.2115 10.0215C67.07 8.91963 65.4677 8.24674 63.6075 8.28038C59.9294 8.34346 57.304 11.1528 57.3632 14.5215V14.5551C57.4224 17.928 60.1112 20.607 63.7893 20.5439C65.7214 20.5103 67.3575 19.6439 68.4694 18.378L66.7022 16.6622C66.0469 17.5369 65.0027 18.1131 63.7809 18.1341V18.1383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.202 8.49487H124.009V20.3547H121.51V12.6038L118.128 17.6799H118.052L114.674 12.6038V20.3547H112.176V8.49487H114.983L118.09 13.4701L121.202 8.49487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.029 8.49487L126.956 20.3547H129.628L130.719 17.6967H135.758L136.849 20.3547H139.593L134.519 8.49487H132.029ZM131.657 15.3921L133.242 11.5481L134.828 15.3921H131.661H131.657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2456 24.6402L76.1724 36.5H78.8443L79.935 33.8421H84.9745L86.0653 36.5H88.8091L83.7358 24.6402H81.2456ZM80.8736 31.5374L82.459 27.6935L84.0444 31.5374H80.8778H80.8736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.855 27.0122V29.5355H126.465V31.9075H120.855V36.5H118.234V24.6402H127.315V27.0122H120.855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3609 24.6402L70.6002 32.9L67.8352 24.6402H65.307L62.5421 32.9L59.7814 24.6402H56.9742L61.2696 36.5H63.8781L66.5711 28.358L69.2684 36.5H71.8727L76.1681 24.6402H73.3609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.867 17.4276L171.246 15.8967L169.588 14.1346L168.366 15.5645L166.883 13.8108C167.863 13.2388 168.481 12.179 168.443 11.0855C168.388 9.47898 167.06 8.26776 165.361 8.26776C164.545 8.26776 163.792 8.57898 163.251 9.13832C162.71 9.69767 162.426 10.4463 162.456 11.2453C162.486 12.1411 163.09 12.8897 163.53 13.4112C162.118 13.9958 161.091 15.4636 161.137 16.8893C161.209 18.9164 162.968 20.565 165.065 20.565C166.236 20.565 167.538 19.9299 168.328 19.0551L169.394 20.3505H172.467L169.859 17.4192L169.867 17.4276ZM166.925 17.3224C166.371 18.0374 165.678 18.4285 165.073 18.4285C164.215 18.4285 163.462 17.7136 163.433 16.8682C163.416 16.3425 163.822 15.5561 165.005 15.0178L166.925 17.3224ZM165.449 12.3935C165.128 12.1033 164.756 11.6995 164.688 11.2916C164.621 10.8836 164.887 10.379 165.462 10.3411C166.037 10.3033 166.388 10.7365 166.388 11.2117C166.388 11.7584 165.826 12.1916 165.449 12.3935Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139_29890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172.5,
    height: 36,
    fill: "white",
    transform: "translate(0.500122 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCushmanAndWakefield);
export default __webpack_public_path__ + "static/media/CushmanAndWakefield.464cc7dcf5d2a294b9bf514ca0b32974.svg";
export { ForwardRef as ReactComponent };